import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withModifiers as _withModifiers, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "create-notes"
}
const _hoisted_2 = { class: "quantity" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Título da nota"),
  /*#__PURE__*/_createTextVNode(" (obrigatório)")
], -1)
const _hoisted_4 = { class: "content-section" }
const _hoisted_5 = { class: "content-section__header" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h1", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Descrição para a nota"),
    /*#__PURE__*/_createTextVNode(" (obrigatório)")
  ]),
  /*#__PURE__*/_createElementVNode("h2", null, "Descreva os detalhes que você precisa guardar para lembrar depois.")
], -1)
const _hoisted_7 = ["disabled"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M12 3L13.7 8.3L19 10L13.7 11.7L12 17L10.3 11.7L5 10L10.3 8.3L12 3Z",
    fill: "currentColor"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M19 15L19.8 17.2L22 18L19.8 18.8L19 21L18.2 18.8L16 18L18.2 17.2L19 15Z",
    fill: "currentColor"
  })
], -1)
const _hoisted_9 = {
  key: 0,
  class: "ai-summary"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Vincular a um documento")
], -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h2", null, "Se desejar, pode vincular essa nota a um documento específico", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("path", {
  d: "M17.5002 17.5002L13.881 13.881M13.881 13.881C14.5001 13.2619 14.9912 12.527 15.3262 11.7181C15.6612 10.9093 15.8337 10.0423 15.8337 9.16684C15.8337 8.29134 15.6612 7.42441 15.3262 6.61555C14.9912 5.80669 14.5001 5.07174 13.881 4.45267C13.2619 3.8336 12.527 3.34252 11.7181 3.00748C10.9093 2.67244 10.0423 2.5 9.16684 2.5C8.29134 2.5 7.42441 2.67244 6.61555 3.00748C5.80669 3.34252 5.07174 3.8336 4.45267 4.45267C3.2024 5.70295 2.5 7.39868 2.5 9.16684C2.5 10.935 3.2024 12.6307 4.45267 13.881C5.70295 15.1313 7.39868 15.8337 9.16684 15.8337C10.935 15.8337 12.6307 15.1313 13.881 13.881Z",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("path", {
  d: "M4 4L16 16",
  stroke: "#079F72",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("path", {
  d: "M16 4L4 16",
  stroke: "#079F72",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_16 = [
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = ["id", "value", "checked", "onChange"]
const _hoisted_18 = ["for"]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "13",
    height: "10",
    viewBox: "0 0 13 10",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_note_doc)" }, [
      /*#__PURE__*/_createElementVNode("path", { d: "M12.3047 2.42188C12.3047 2.63021 12.2318 2.80729 12.0859 2.95312L6.42969 8.60938L5.36719 9.67188C5.22135 9.81771 5.04427 9.89062 4.83594 9.89062C4.6276 9.89062 4.45052 9.81771 4.30469 9.67188L3.24219 8.60938L0.414062 5.78125C0.268229 5.63542 0.195312 5.45833 0.195312 5.25C0.195312 5.04167 0.268229 4.86458 0.414062 4.71875L1.47656 3.65625C1.6224 3.51042 1.79948 3.4375 2.00781 3.4375C2.21615 3.4375 2.39323 3.51042 2.53906 3.65625L4.83594 5.96094L9.96094 0.828125C10.1068 0.682292 10.2839 0.609375 10.4922 0.609375C10.7005 0.609375 10.8776 0.682292 11.0234 0.828125L12.0859 1.89062C12.2318 2.03646 12.3047 2.21354 12.3047 2.42188Z" })
    ]),
    /*#__PURE__*/_createElementVNode("defs", null, [
      /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_note_doc" }, [
        /*#__PURE__*/_createElementVNode("rect", {
          width: "12.5",
          height: "10",
          fill: "white"
        })
      ])
    ])
  ])
], -1)
const _hoisted_20 = {
  key: 0,
  class: "doc-empty"
}
const _hoisted_21 = ["disabled", "onClick"]
const _hoisted_22 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 24 24",
  fill: "none"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("path", {
  d: "M15 18l-6-6 6-6",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 24 24",
  fill: "none"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("path", {
  d: "M9 18l6-6-6-6",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Data para alerta"),
  /*#__PURE__*/_createTextVNode(" (obrigatório)")
], -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("h2", null, "Quando você quer ser alertado sobre essa nota?", -1)
const _hoisted_30 = ["value"]
const _hoisted_31 = /*#__PURE__*/_createStaticVNode("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\"><path d=\"M8 2V5\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M16 2V5\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M3.5 9.08984H20.5\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M21 8.5V17C21 20 19.5 22 16 22H8C4.5 22 3 20 3 17V8.5C3 5.5 4.5 3.5 8 3.5H16C19.5 3.5 21 5.5 21 8.5Z\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M15.6937 13.7002H15.7027\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M15.6937 16.7002H15.7027\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M11.9945 13.7002H12.0035\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M11.9945 16.7002H12.0035\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M8.29529 13.7002H8.30427\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M8.29529 16.7002H8.30427\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg>", 1)
const _hoisted_32 = { class: "spacing" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Status"),
  /*#__PURE__*/_createTextVNode(" (obrigatório)")
], -1)
const _hoisted_34 = {
  class: "status-toggle",
  for: "note-status"
}
const _hoisted_35 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_36 = ["disabled"]
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "modal-date-title" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Data para alerta"),
  /*#__PURE__*/_createElementVNode("h2", null, "Quando você quer ser alertado sobre essa nota?")
], -1)

import { computed, onMounted, ref } from 'vue'
import { useAxios } from '@/api/axios'
import { toast } from 'vue3-toastify'
import { AxiosResponse } from 'axios'
import NoteModel from '@/models/NoteModel'
import NoteStatusEnum from '@/enums/NoteStatusEnum'
import PaginationModel from '@/models/PaginationModel'
import MyModal from '@/components/modal/MyModal.vue'
import MyDatePicker from '@/components/date/MyDatePicker.vue'
import MyOptions from '@/components/options/MyOptions.vue'
import TextEditor from '@/components/input/TextEditor.vue'
import SpinnerLoader from '@/components/loader/SpinnerLoader.vue'
import SpinnerLoaderButton from '@/components/loader/SpinnerLoaderButton.vue'
import { hasAiModule } from '@/global/states/GlobalState'

interface DocumentOption {
  id: number
  number: number
  title: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateNoteView',
  props: {
    id: {}
  },
  setup(__props: any) {

const props = __props
const axios = useAxios()
const isEditing = computed(() => !!props.id)

const payload = ref<Partial<NoteModel>>({})
const isActive = ref(true)
const selectedEventDate = ref('')
const isEventDateModalOpen = ref(false)
const eventDatePickerKey = ref(0)

function openDateModal () {
  eventDatePickerKey.value++
  isEventDateModalOpen.value = true
}
const isSaving = ref(false)
const editorKey = ref(0)

/* AI SUMMARIZATION */
const isSummarizingNote = ref(false)
const noteSummary = ref('')

function summarizeNote (): void {
  if (!payload.value.description || isSummarizingNote.value) return

  isSummarizingNote.value = true

  const body = new FormData()
  body.append('content', payload.value.description)

  axios.post('/api/ai/summarize-content', body)
    .then((res) => {
      noteSummary.value = res.data.summary
    })
    .catch((error) => {
      if (!error?.response?.data?.errors) {
        toast.error('Não foi possível gerar o resumo com IA. Tente novamente.')
      }
    })
    .finally(() => {
      isSummarizingNote.value = false
    })
}
/* AI SUMMARIZATION */

const documents = ref<PaginationModel<DocumentOption> | null>(null)
const selectedDocuments = ref<DocumentOption[]>([])
const docSearch = ref('')
const isLoadingDocs = ref(false)

const formattedEventDate = computed(() => payload.value.event_date ? formatDate(payload.value.event_date) : undefined)

function formatDate (date: string): string {
  const [year, month, day] = date.split('-')
  return `${day}/${month}/${year}`
}

function toggleDocument (doc: DocumentOption, checked: boolean): void {
  if (checked) {
    if (!selectedDocuments.value.some(d => d.id === doc.id)) {
      selectedDocuments.value.push(doc)
    }
  } else {
    selectedDocuments.value = selectedDocuments.value.filter(d => d.id !== doc.id)
  }
}

function getDocuments (page: number = 1): void {
  isLoadingDocs.value = true
  axios.get('/api/documents', { params: { per_page: 10, compact: true, page, search: docSearch.value || undefined } })
    .then((res: AxiosResponse<PaginationModel<DocumentOption>>) => {
      documents.value = res.data
    })
    .finally(() => { isLoadingDocs.value = false })
}

function createNote (): void {
  isSaving.value = true
  axios.post('/api/notes', {
    title: payload.value.title,
    description: payload.value.description ?? null,
    event_date: payload.value.event_date,
    document_ids: selectedDocuments.value.map(d => d.id),
    status: isActive.value ? NoteStatusEnum.ACTIVE : NoteStatusEnum.INACTIVE,
  })
    .then(() => {
      payload.value = {}
      selectedDocuments.value = []
      isActive.value = true
      editorKey.value++
      toast.success('Nota criada com sucesso')
    })
    .finally(() => isSaving.value = false)
}

function updateNote (): void {
  isSaving.value = true
  axios.patch(`/api/notes/${props.id}`, {
    title: payload.value.title,
    description: payload.value.description ?? null,
    event_date: payload.value.event_date,
    document_ids: selectedDocuments.value.map(d => d.id),
    status: isActive.value ? NoteStatusEnum.ACTIVE : NoteStatusEnum.INACTIVE,
  })
    .then(() => {
      toast.success('Nota editada com sucesso')
    })
    .finally(() => isSaving.value = false)
}

function getNote (): void {
  axios.get(`/api/notes/${props.id}`)
    .then((res: AxiosResponse<NoteModel>) => {
      const note = res.data
      payload.value = { ...note }
      isActive.value = note.status === NoteStatusEnum.ACTIVE
      if (note.documents?.length) {
        selectedDocuments.value = note.documents.map(d => ({ id: d.id, number: d.number, title: d.title }))
      }
    })
}

onMounted(() => {
  getDocuments()
  if (isEditing.value) {
    getNote()
  } else {
    const now = new Date()
    const y = now.getFullYear()
    const m = String(now.getMonth() + 1).padStart(2, '0')
    const d = String(now.getDate()).padStart(2, '0')
    payload.value.event_date = `${y}-${m}-${d}`
  }
})

return (_ctx: any,_cache: any) => {
  return (!isEditing.value || payload.value.id)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("section", _hoisted_2, [
          _hoisted_3,
          _withDirectives(_createElementVNode("input", {
            maxlength: 255,
            type: "text",
            placeholder: "Ex: Envio de folha de pagamento",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((payload.value.title) = $event))
          }, null, 512), [
            [_vModelText, payload.value.title]
          ]),
          _createElementVNode("p", null, _toDisplayString((payload.value.title ?? '').length) + "/255", 1)
        ]),
        _createElementVNode("section", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            (_unref(hasAiModule))
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "ai-toggle-button",
                  disabled: !payload.value.description || isSummarizingNote.value,
                  onClick: summarizeNote
                }, [
                  _hoisted_8,
                  _createTextVNode(" " + _toDisplayString(isSummarizingNote.value ? 'Resumindo...' : 'Resumir com IA'), 1)
                ], 8, _hoisted_7))
              : _createCommentVNode("", true)
          ]),
          (noteSummary.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("p", null, _toDisplayString(noteSummary.value), 1),
                _createElementVNode("button", {
                  type: "button",
                  class: "ai-summary__close",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (noteSummary.value = ''))
                }, "Fechar")
              ]))
            : _createCommentVNode("", true),
          (_openBlock(), _createBlock(TextEditor, {
            key: editorKey.value,
            value: payload.value.description ?? '',
            setValue: (value) => payload.value.description = value
          }, null, 8, ["value", "setValue"]))
        ]),
        _createElementVNode("section", null, [
          _hoisted_10,
          _hoisted_11,
          _createVNode(MyOptions, {
            currentValue: selectedDocuments.value.length ? `${selectedDocuments.value.length} documento(s) selecionado(s)` : 'Selecione'
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: "doc-search-wrapper",
                onClick: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"]))
              }, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  placeholder: "Pesquisar documento...",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((docSearch).value = $event)),
                  onKeydown: _cache[3] || (_cache[3] = _withKeys(_withModifiers(($event: any) => (getDocuments(1)), ["prevent"]), ["enter"]))
                }, null, 544), [
                  [_vModelText, docSearch.value]
                ]),
                (!docSearch.value)
                  ? (_openBlock(), _createElementBlock("svg", {
                      key: 0,
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (getDocuments(1))),
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "16",
                      height: "16",
                      viewBox: "0 0 20 20",
                      fill: "none"
                    }, _hoisted_13))
                  : (_openBlock(), _createElementBlock("svg", {
                      key: 1,
                      onClick: _cache[5] || (_cache[5] = ($event: any) => {docSearch.value = ''; getDocuments(1)}),
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "16",
                      height: "16",
                      viewBox: "0 0 20 20",
                      fill: "none"
                    }, _hoisted_16))
              ]),
              (isLoadingDocs.value)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, _renderList(5, (i) => {
                    return _createElementVNode("div", {
                      class: "doc-skeleton",
                      key: 'sk-' + i
                    })
                  }), 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(documents.value?.data ?? [], (doc) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "item",
                        key: doc.id,
                        onClick: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"]))
                      }, [
                        _createElementVNode("input", {
                          type: "checkbox",
                          id: 'document-' + doc.id,
                          value: doc.id,
                          checked: selectedDocuments.value.some(d => d.id === doc.id),
                          onChange: ($event: any) => (toggleDocument(doc, ($event.target as HTMLInputElement).checked))
                        }, null, 40, _hoisted_17),
                        _createElementVNode("label", {
                          for: 'document-' + doc.id
                        }, [
                          _hoisted_19,
                          _createElementVNode("p", null, "#" + _toDisplayString(doc.number) + " — " + _toDisplayString(doc.title), 1)
                        ], 8, _hoisted_18)
                      ]))
                    }), 128)),
                    (documents.value && !documents.value.data.length)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_20, "Nenhum documento encontrado."))
                      : _createCommentVNode("", true)
                  ], 64)),
              (!isLoadingDocs.value && documents.value && documents.value.links.length > 3)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 2,
                    class: "doc-pagination",
                    onClick: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["stop"]))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(documents.value.links, (link, index) => {
                      return (_openBlock(), _createElementBlock("button", {
                        key: index,
                        disabled: (index == 0 && !documents.value.prev_page_url) || (index == documents.value.links.length - 1 && !documents.value.next_page_url),
                        onClick: _withModifiers(($event: any) => (getDocuments(index != 0 && (index != documents.value.links.length - 1) ? parseInt(link.label) : (documents.value.current_page + (index ? 1 : -1)))), ["stop"]),
                        class: _normalizeClass({ active: link.active, passers: index == 0 || index == documents.value.links.length - 1 })
                      }, [
                        (index == 0)
                          ? (_openBlock(), _createElementBlock("svg", _hoisted_22, _hoisted_24))
                          : (index == documents.value.links.length - 1)
                            ? (_openBlock(), _createElementBlock("svg", _hoisted_25, _hoisted_27))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                _createTextVNode(_toDisplayString(link.label), 1)
                              ], 64))
                      ], 10, _hoisted_21))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["currentValue"])
        ]),
        _createElementVNode("section", null, [
          _hoisted_28,
          _hoisted_29,
          _createElementVNode("label", {
            class: "date-picker-label",
            for: "event_date",
            onClick: _cache[9] || (_cache[9] = ($event: any) => (openDateModal()))
          }, [
            _createElementVNode("input", {
              type: "text",
              placeholder: "Selecione uma data",
              name: "event_date",
              value: formattedEventDate.value ?? '',
              id: "event_date",
              readonly: ""
            }, null, 8, _hoisted_30),
            _hoisted_31
          ])
        ]),
        _createElementVNode("section", _hoisted_32, [
          _hoisted_33,
          _createElementVNode("label", _hoisted_34, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              name: "note-status",
              id: "note-status",
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((isActive).value = $event))
            }, null, 512), [
              [_vModelCheckbox, isActive.value]
            ]),
            _hoisted_35
          ])
        ]),
        _createElementVNode("nav", null, [
          (!isSaving.value)
            ? (_openBlock(), _createElementBlock("input", {
                key: 0,
                type: "button",
                value: "salvar nota",
                onClick: _cache[11] || (_cache[11] = ($event: any) => (isEditing.value ? updateNote() : createNote())),
                disabled: !payload.value.title || !payload.value.event_date
              }, null, 8, _hoisted_36))
            : (_openBlock(), _createBlock(SpinnerLoaderButton, {
                key: 1,
                height: 60,
                maxWidth: 464
              })),
          _createElementVNode("input", {
            type: "button",
            value: "cancelar",
            onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.$router.go(-1)))
          })
        ]),
        _createVNode(MyModal, {
          width: '341px !important',
          height: '517px !important',
          className: 'date-limit',
          isOpen: isEventDateModalOpen.value,
          toggleModal: (v) => isEventDateModalOpen.value = v,
          zIndex: 100
        }, {
          default: _withCtx(() => [
            _hoisted_37,
            (_openBlock(), _createBlock(MyDatePicker, {
              key: eventDatePickerKey.value,
              min: { day: 1, month: 1, year: 2000 },
              name: 'event_date',
              initialDate: payload.value.event_date,
              setValue: (date) => selectedEventDate.value = date
            }, null, 8, ["initialDate", "setValue"])),
            _createElementVNode("input", {
              type: "button",
              value: "Aplicar data",
              onClick: _cache[13] || (_cache[13] = ($event: any) => {payload.value.event_date = selectedEventDate.value; isEventDateModalOpen.value = false})
            })
          ]),
          _: 1
        }, 8, ["isOpen", "toggleModal"])
      ]))
    : (_openBlock(), _createBlock(SpinnerLoader, { key: 1 }))
}
}

})